export default function _identity(x) {
  return x;
}


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/ramda/es/internal/_identity.js
// module id = 216
// module chunks = 2 3 4 5 6 7 8 10